import { flash } from "@xola/ui-kit";
import React, { ReactNode } from "react";
import { renderToString } from "../../utils/renderToString";

export const SupportItem = ({ name, value, copyText }: { name: string; value: ReactNode; copyText?: string }) => {
    const handleClick = () => {
        const copyString = copyText ?? renderToString(value as JSX.Element);
        flash.success(
            <span>
                Copied
                <span className="px-1 font-mono font-semibold">
                    <var data-var="copystring">{copyString}</var>
                </span>
                to clipboard
            </span>,
        );
        navigator.clipboard.writeText(copyString);
    };

    return (
        <div
            className="grid cursor-copy grid-cols-2"
            style={{ gridTemplateColumns: "130px auto" }}
            onClick={handleClick}
        >
            <span className="text-gray-darker">{name}:</span>
            <span className="no-translate">{value}</span>
        </div>
    );
};
